import React from 'react';

const Message = ({ setMessage, message }) => {
  return (
    <div className='p-3 border-gray-400 border rounded-lg bg-yellow-50 text-center'>
      <label className='w-full flex mt-4 text-sm text-gray-600 items-start font-medium gap-x-3'>
        <input
          type='checkbox'
          value={1}
          className='mt-1'
          onChange={() => setMessage(!message)}
          checked={message}
        />
        <span className='text-left'>
          Autorizo al Centro de Arbitraje de la Cámara de Comercio e Industria
          de Arequipa (Centro) a tratar todos los datos personales consignados
          en este formulario, pudiendo mostrarlos al público y entidades del
          Estado cuando sean requeridos, conforme las normas vigentes. Asimismo,
          autorizo al Centro para que la información consignada pueda ser
          remitida al Organismo Especializado para las Contrataciones Públicas
          Eficientes - OECE u otra entidad del Estado, según lo establecido en
          Ley N° 32069, su Reglamento y cualquier otra normativa relacionada.
          Los datos ofrecidos serán empleados única y exclusivamente para los
          fines referidos, en concordancia con la Ley N° 29733, Ley de
          Protección de Datos Personales y su Reglamento, Decreto Supremo N.°
          003-2013-JUS. Autorizo al Centro a guardar los datos consignados en su
          base de datos. Las autorizaciones consignadas las hago de manera
          indefinida salvo que las revoque de manera expresa.
        </span>
      </label>
    </div>
  );
};

export default Message;
